<div class="position-relative">
  <!--@if (customerListConfigService?.isCustomerService) {
  <button class="btn btn-outline-primary create-customer-button" (click)="openAddCustomerModal()">
    <i class="fa fa-lg fa-circle-plus"></i> {{ 'CUSTOMER' | translate }}
  </button>
}-->

  <lib-filter-list #customerExportList [configService]="customerListConfigService"></lib-filter-list>
</div>
